
export default function InitMobileHeader() {
  const mobileMenu = document.querySelector(".header__menu.mobile-menu")
  if (!mobileMenu) return

  mobileMenu.addEventListener('click', (e) => {
    const arrow = e.target.closest('.item__link--arrow')
    const li = e.target.closest('[data-submenu]')
    const panel = e.target.closest('.mobile-menu__panel')

    if (arrow && panel && li && mobileMenu.contains(panel)) {
      const newPanel = document.getElementById(`menu-panel-${li.dataset.submenu}`);
      if (newPanel) {
        panel.classList.remove('is-active')
        newPanel.classList.add('is-active')
      }
      return
    }

    const backBtn = e.target.closest('.mobile-menu__back');
    if (backBtn) {
      const currentPanel = backBtn.closest('.mobile-menu__panel');
      const parentId = currentPanel.dataset.parentId;
      const parentPanel = document.getElementById(`menu-panel-${parentId}`);

      if (currentPanel && parentPanel) {
        currentPanel.classList.remove('is-active');
        parentPanel.classList.add('is-active');
      }
    }
  })

}
